/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvTlJFR0UzL1dvcmtzcGFjZS9PblByZW1DaGluYS9QYWNrSVRXZWJHdWkvc3JjL2FwcC9wYWNrYWdpbmctY29kZS9wYWNrYWdpbmctY29kZS5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvTlJFR0UzL1dvcmtzcGFjZS9PblByZW1DaGluYS9QYWNrSVRXZWJHdWkvc3JjL2FwcC9wYWNrYWdpbmctY29kZS9wYWNrYWdpbmctY29kZS5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/$$_gendir/app/packaging-code/packaging-code.css.shim.ngstyle.ts